import { reactive,ref } from "vue";
import api from '@/api/api.js';
let doctor;
const state = reactive({
  logout:'',
  token:'',
  user:'',
  operation:'',
  stateDoctor:'',
});
api.apiGetDuty().then(function (response) { 
  doctor = ref([[null,null,null],[null,null,null],[null,null,null],[null,null,null],[null,null,null],[null,null,null],[null,null,null]]);
  doctor.value[0][0] = response.data.doctor11;
  doctor.value[0][1] = response.data.doctor12;
  doctor.value[0][2] = response.data.doctor13;
  doctor.value[1][0] = response.data.doctor21;
  doctor.value[1][1] = response.data.doctor22;
  doctor.value[1][2] = response.data.doctor23;
  doctor.value[2][0] = response.data.doctor31;
  doctor.value[2][1] = response.data.doctor32;
  doctor.value[2][2] = response.data.doctor33;
  doctor.value[3][0] = response.data.doctor41;
  doctor.value[3][1] = response.data.doctor42;
  doctor.value[3][2] = response.data.doctor43;
  doctor.value[4][0] = response.data.doctor51;
  doctor.value[4][1] = response.data.doctor52;
  doctor.value[4][2] = response.data.doctor53;  
  doctor.value[5][0] = response.data.doctor61;
  doctor.value[5][1] = response.data.doctor62;
  doctor.value[5][2] = response.data.doctor63;  
  doctor.value[6][0] = response.data.doctor71;
  doctor.value[6][1] = response.data.doctor72;
  doctor.value[6][2] = response.data.doctor73; 
  state.stateDoctor = doctor.value; 
  console.log(state)
}).catch(function (error) {
  console.log(error);
});

export default {
  state: state,
};